import produce from "immer";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchInstructionChapters,
  fetchInstructionChapter,
  updateInstructionChapter,
  createInstructionChapter,
  deleteInstructionChapter,
} from "../../api/quality/instruction_chapter";

const initialState = {
  isLoading: false,
  error: false,
  errors: null,
  data: [],
  instructionsWithoutChapter: [],
  totalCount: 0,
  currentCount: 0,
  newCount: 0,
};

export const initialController = {
  filters: [],
  page: 0,
  query: "",
  sort: "desc",
  sortBy: "created_at",
  view: "all",
};

export const deleteInstructionChapterAsync = createAsyncThunk(
  "instruction_chapters/deleteInstructionChapterAsync",
  async (payload) => {
    let response = await deleteInstructionChapter(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const createInstructionChapterAsync = createAsyncThunk(
  "instruction_chapters/createInstructionChapterAsync",
  async (payload) => {
    let response = await createInstructionChapter(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const updateInstructionChapterAsync = createAsyncThunk(
  "instruction_chapters/updateInstructionChapterAsync",
  async (payload) => {
    let response = await updateInstructionChapter(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);
export const getInstructionChaptersAsync = createAsyncThunk(
  "instruction_chapters/getInstructionChaptersAsync",
  async (controller = initialController, { rejectWithValue }) => {
    // if (! controller) return false;
    let response = await fetchInstructionChapters(controller);
    // If errors, reject and return response
    if (response.response?.status?.match(/404|500|401/))
      return rejectWithValue(true);

    // If all good, return response.
    return response;
  }
);

export const getInstructionChapterAsync = createAsyncThunk(
  "instruction_chapters/getInstructionChapterAsync",
  async (id, { rejectWithValue }) => {
    // if (! controller) return false;
    let response = await fetchInstructionChapter(id);

    // If errors, reject and return response
    if (response.error) return rejectWithValue(response);

    // If all good, return response.
    return response;
  }
);

const instructionChapterSlice = createSlice({
  name: "instruction_chapters",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInstructionChaptersAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInstructionChaptersAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data || [];
        state.instructionsWithoutChapter = action.payload.instructionsWithoutChapter || [];
        state.totalCount = action.payload.totalCount || 0;
        state.currentCount = action.payload.currentCount || 0;
        state.newestInstructionChaptersCount = action.payload.newCount || 0;
      })
      .addCase(getInstructionChaptersAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to fetch instruction chapters....is controller missing?",
        ];
      })
      .addCase(updateInstructionChapterAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateInstructionChapterAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          const index = draftState.data.findIndex(
            (type) => type.id === action.payload.id
          );
          draftState.data[index] = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(updateInstructionChapterAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update instruction chapter"];
      })
      .addCase(createInstructionChapterAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createInstructionChapterAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data.push(action.payload);
          draftState.isLoading = false;
        });
      })
      .addCase(createInstructionChapterAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to create instruction chapter"];
      })
      .addCase(deleteInstructionChapterAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteInstructionChapterAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(deleteInstructionChapterAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to delete instruction chapter"];
      })
      .addCase(getInstructionChapterAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInstructionChapterAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.chapter = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(getInstructionChapterAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to get instruction chapter."];
      });
  },
});

// export const {} = customerSlice.actions;

export const { reducer } = instructionChapterSlice;

export default instructionChapterSlice;
